export const inputs = [
  { field: 'id', text: 'Номер отчета' },
  { field: 'load_point', text: 'Место погрузки' },
  { field: 'author', text: 'Отчет создал' },
]
export const statusOptions = [
  { value: 'created', label: 'Создан' },
  { value: 'pending_agreement', label: 'Согласовывается заказчиком' },
  { value: 'lacking_documents', label: 'Не хватает документов' },
  { value: 'passed', label: 'Сдан' },
  { value: 'documents_sent', label: 'Отправлены оригиналы' },
  { value: 'paid', label: 'Оплачен' },
]

export const dates = [
  { field: 'date_from', text: 'искать с' },
  { field: 'date_to', text: 'искать по' },
]

// тестовые данные для комментариев
export const comments = [
  {
    text: 'Проверка работы комментариев',
    created_at: '2022-08-05 11:11:30',
    user_fio: 'Зайцева Полина Александровна',
  },
  {
    text: 'Ну вроде работают',
    created_at: '2022-08-06 11:30:30',
    user_fio: 'Иванов Иван Иванович',
  },
  {
    text: 'Как они могут работать, если бэк не подключен?',
    created_at: '2022-08-07 11:40:30',
    user_fio: 'Зайцева Полина Александровна',
  },
  {
    text: 'Но мы же это как-то читаем?',
    created_at: '2022-08-07 19:30:30',
    user_fio: 'Иванов Иван Иванович',
  },
  {
    text: 'Это же просто моки, чтобы проверить работу комментариев. Дальше пойдет один и тот же текст, чисто чтобы проверить скролл при большом количестве комментов',
    created_at: '2022-08-08 21:13:30',
    user_fio: 'Зайцева Полина Александровна',
  },
  {
    text: 'Проверка работы комментариев',
    created_at: '2022-08-08 21:14:30',
    user_fio: 'Зайцева Полина Александровна',
  },
  {
    text: 'Проверка работы комментариев',
    created_at: '2022-08-08 21:15:30',
    user_fio: 'Зайцева Полина Александровна',
  },
  {
    text: 'Проверка работы комментариев',
    created_at: '2022-08-08 21:16:30',
    user_fio: 'Зайцева Полина Александровна',
  },
]
